class ConfiguratorLegs {
    cylindo_mapping = {
        'classiclegs-aluminium-#size#': 'CLASSIC-BED-LEGS-ALUMINIUM-#size#',
        'classiclegs-black-#size#': 'CLASSIC-BED-LEGS-BLACK-#size#',
        'classiclegs-copper-#size#': 'CLASSIC-BED-LEGS-COPPER-#size#',
        'cylinderalulegs-black-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-BLACK-ALU-#size#',
        'cylinderalulegs-grey-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-GREY-ALU-#size#',
        'cylinderalulegs-oak-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-OAK-ALU-#size#',
        'cylinderalulegs-wenge-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-WENGE-ALU-#size#',
        'cylinderalulegs-white-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-WHITE-ALU-#size#',
        'cylinderlegs-oak-#size#': 'CYLINDER-BED-LEG-OAK-#size#',
        'cylinderlegs-wenge-#size#': 'CYLINDER-BED-LEG-WENGE-#size#',
        'cylinderlegs-walnut-#size#': 'CYLINDER-BED-LEG-WALNUT-#size#',
        'lodlegs-black-#size#': 'LOD-BED-LEGS-BLACK-#size#',
        'lodlegs-brass-#size#': 'LOD-BED-LEGS-BRASS-#size#',
        'lodlegs-chrome-#size#': 'LOD-BED-LEGS-CHROME-#size#',
        'segellegs-aluminium-#size#': 'SEGEL-BED-LEGS-ALUMINIUM-#size#',
        'reling-black': 'RELING-BED-LEGS-BLACK-13',
        'reling-brass': 'RELING-BED-LEGS-BRASS-13',
        'reling-chrome': 'RELING-BED-LEGS-CHROME-13',
    }

    constructor() {
        this.id = 'legs';
        this.cache = {};
        this.items = {};
        this.buyables = {};

        this.selectors = [
            'legs'
        ];

        this.sizes = bed_configuration.sizes;

        //configurator.initSelector(this);
        configurator.addSelectorItem(this.id);
    }

    async refresh(selector) {
        await this.loadItems(configurator.selection.size);
        this.populateItems();
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    async loadItems(size) {
        const size_arr = size.split('x');
        let width = parseInt(size_arr[0]);
        const is_double = width > 140 ? true : false;

        // Check if already loaded
        if (Object.keys(this.cache).length > 0) {
            return;
        }

        // Load Legs
        const products = await configurator.loadProductData('configurator-legs', [], [], true); // Load images

        for (const size of bed_configuration.sizes) {
            const size_arr = size.split('x');
            if (!(size in this.cache)) {
                this.cache[size] = {
                    'title': size, 'products': {},
                };
            }

            for (const product of products) {
                for (const variant of product.variants) {
                    if (variant.option2 == null) { continue; }

                    // Skip variants with price 0 when e-commerce is enabled
                    if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                    // Skip if SKU is globally excluded
                    if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(variant.sku)) {
                        console.log(`Leg SKU ${variant.sku} excluded globally.`);
                        continue;
                    }

                    const variant_id = variant.id.replace('gid://shopify/ProductVariant/', '');
                    let lbl = ""; //[variant.option1, variant.option2, variant.option3].join(" ");
                    let variant_handle = ""; //product.handle + '-' + variant.title.toLowerCase().replace(/\s/g, '').replace(/\//g, '-');

                    const skus = [];
                    const ids = [];
                    let price = 0;

                    if (product.productid.includes('reling')) {
                        const is_double = (bed_configuration.specs.heavy == true && size_arr[0] >= 160 );
                        const arr = variant.option1.split('x');

                        // Filter out all legs with non matching widths
                        if (size_arr[0]/(1 + is_double) != arr[0]) continue;

                        // Update title to reflect leg count
                        lbl = `${is_double ? '2 x ' : ''}${arr[0]}x${arr[1]} ${variant.option2}`;

                        variant_handle = product.productid + '-' + variant.option2.toLowerCase().replace(/\s/g, '').replace(/\//g, '-');

                        skus.push(variant.sku);
                        ids.push(variant_id);
                        price = variant.price;
                        if (is_double) {
                            skus.push(variant.sku);
                            ids.push(variant_id);
                            price = 2 * price;
                        }

                    } else {
                        const is_double = (size_arr[0] >= 160);
                        lbl = `${is_double ? '8 x ' : '4 x '}${variant.option2} ${variant.option1}`; //[variant.option1, variant.option2, variant.option3].join(" ");
                        variant_handle = product.productid + '-' + variant.option2.toLowerCase().replace(/\s/g, '').replace(/\//g, '-') + '-' + variant.option1.replace(' cm', '');

                        skus.push(variant.sku);
                        ids.push(variant_id);
                        price = variant.price;
                        if (is_double) {
                            skus.push(variant.sku);
                            ids.push(variant_id);
                            price = 2 * price;
                        }
                    }

                    this.cache[size]['products'][variant_handle] = {
                        'id': variant_handle,
                        'label': lbl,
                        'skus': skus,
                        'ids': ids,
                        'price': price,
                        'thumbnail': variant.image ? variant.image : product.image, //(product.images.length > 0 ? product.images[0].src: null),
                        'group_by': product.title,
                        'available': variant.availableForSale,
                    };
                }
            }
        }
    }

    populateItems() {
        let sel_size = configurator.selection.size;
        this.items = this.cache[sel_size]['products'];

        configurator.renderSelector(this.id, Object.values(this.items), {
            'thumbnails': true,
            'columns': 3,
            'allow_none': false,
        });
    }

    isSoldOut() {
        const item = this.items[ configurator.selection.legs ];

        if (item && item.available) return false;
        return true;
    }

    getPriceData(priceData) {
        const item = this.items[ configurator.selection.legs ];

        if (item != null) {
            priceData.total += item.price ?? 0;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate Legs config ==============
        if (configurator.selection.legs == null) {
            specs.features['LEGS'] = 'OFF';
            return;
        }

        let key = configurator.selection.legs;

        console.log("key", key);

        if (key.includes('reling')) {
            if (key in this.cylindo_mapping) {
                specs.features['LEGS'] = this.cylindo_mapping[key];
                return;
            }
        } else {
            const sizes = {'13': '13', '17': '13', '23': '23', '30': '23'};
            for (const k in sizes) {

                const key2 = key.replace(k, '#size#');
                if (key2 in this.cylindo_mapping) {
                    specs.features['LEGS'] = this.cylindo_mapping[key2].replace('#size#', sizes[k]);
                    return;
                }
            }
        }
    }
}
